





import { Component, Prop, Vue } from 'vue-property-decorator';
import IconCustom from "@/components/lib/IconCustom.vue";

@Component({
  components: {
    IconCustom
  }
})
export default class TimezoneTooltip extends Vue {
  @Prop({ default: 'md' }) readonly size?: string;

  get timezone(): string {
    const offset = new Date().getTimezoneOffset();
    const o = Math.abs(offset);
    const shift = "UTC" + (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) +
      ":" + ("00" + (o % 60)).slice(-2);
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.$t('timezone') + ': ' + (tz ? `${tz}, ` : '') + shift;
  }
}
